import React from "react";

import "./PaymentReturnPage.css";

const PAYMENT_SUBMITTED_RE =
  /^\/billing\/payments\/([0-9a-fA-F-]{36})\/submitted\/?$/;
const PAYMENT_CANCELLED_RE =
  /^\/billing\/invoices\/([0-9a-fA-F-]{36})\/?$/;

export function parsePaymentReturnRoute(pathname, search = "") {
  const path = String(pathname || "").trim();

  const submittedMatch = path.match(PAYMENT_SUBMITTED_RE);
  if (submittedMatch) {
    return {
      kind: "submitted",
      paymentSessionId: submittedMatch[1],
    };
  }

  const cancelledMatch = path.match(PAYMENT_CANCELLED_RE);
  const params = new URLSearchParams(String(search || ""));
  if (cancelledMatch && params.get("payment") === "cancelled") {
    return {
      kind: "cancelled",
      invoiceId: cancelledMatch[1],
    };
  }

  return null;
}

export function parsePaymentReturnHash(hashValue) {
  const raw = String(hashValue || "").trim();
  const normalized = raw.startsWith("#") ? raw.slice(1) : raw;
  const queryIndex = normalized.indexOf("?");

  const pathname =
    queryIndex >= 0 ? normalized.slice(0, queryIndex) : normalized;
  const search =
    queryIndex >= 0 ? normalized.slice(queryIndex) : "";

  return parsePaymentReturnRoute(pathname, search);
}

function OasysMark() {
  return (
    <div className="payment-return-mark" aria-hidden="true">
      <span>O</span>
    </div>
  );
}

export default function PaymentReturnPage({ route }) {
  if (!route) return null;

  const submitted = route.kind === "submitted";

  return (
    <div className="payment-return-page">
      <section
        className="payment-return-card"
        aria-labelledby="payment-return-title"
      >
        <div className="payment-return-brand">
          <OasysMark />
          <div>
            <p className="payment-return-eyebrow">OASYS Solutions</p>
            <span>Secure billing</span>
          </div>
        </div>

        <div
          className={`payment-return-state ${
            submitted ? "is-submitted" : "is-cancelled"
          }`}
          aria-hidden="true"
        >
          {submitted ? "✓" : "×"}
        </div>

        <p className="payment-return-kicker">
          {submitted ? "Payment submitted" : "Payment not completed"}
        </p>

        <h1 id="payment-return-title">
          {submitted
            ? "Your payment was submitted."
            : "Your payment was not completed."}
        </h1>

        {submitted ? (
          <>
            <p>
              OASYS will update the invoice after the payment provider confirms
              the final payment status.
            </p>
            <p className="payment-return-note">
              This confirmation page does not itself mean the invoice is paid.
              Bank payments can remain in processing until settlement is
              confirmed.
            </p>
          </>
        ) : (
          <>
            <p>
              No payment confirmation was received from this checkout attempt.
            </p>
            <p className="payment-return-note">
              You can safely return to the invoice or contact OASYS billing if
              you need help completing payment.
            </p>
          </>
        )}

        <div className="payment-return-actions">
          <a className="payment-return-primary" href="/">
            Return to OASYS
          </a>
          <a
            className="payment-return-secondary"
            href="mailto:billing@oasyshq.com"
          >
            Contact billing
          </a>
        </div>

        <footer>
          Payment status is determined by verified provider reconciliation, not
          by this browser redirect.
        </footer>
      </section>
    </div>
  );
}
